(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/marketplace/components/router/assets/javascripts/start-overview.js') >= 0) return;  svs.modules.push('/modules/marketplace/components/router/assets/javascripts/start-overview.js'); 
'use strict';

const {
  Route
} = ReactRouterDOM;
const {
  lazy
} = svs.components.lbUtils.lazy;
const {
  TabsLoader
} = svs.marketplace.components.router;
const WelcomeScreen = lazy('react:welcome', () => svs.marketplace.components.welcome.WelcomeScreen, {
  fallback: TabsLoader
});
const TeamDetailMasterContainer = lazy('react:team-detail', () => svs.marketplace.components.teamDetail.TeamDetailMasterContainer, {
  fallback: TabsLoader
});
const RetailViewMasterContainer = lazy('react:retail-view', () => svs.marketplace.components.retailView.RetailViewMasterContainer, {
  fallback: TabsLoader
});
const CreateTeamWizard = lazy('/cl/marketplace/react:create-team', () => svs.components.marketplace.createTeam.CreateTeamWizard, {
  fallback: TabsLoader
});
const {
  RedirectToTeamSlugContainer
} = svs.components.marketplace.redirectToSlug;
const teamBaseRoute = '/lag/:groupId([0-9]+):teamPathName([-\\w]*)?';
const retailTeamBaseRoute = '/ombudslag/:groupId([0-9]+):retailerPathName([-\\w]*)?';
const switchedRoutes = [{
  component: WelcomeScreen,
  path: '/bli-medlem/:invitationToken?',
  exact: true
}, {
  component: TeamDetailMasterContainer,
  path: teamBaseRoute
}, {
  component: RetailViewMasterContainer,
  path: retailTeamBaseRoute,
  exakt: true
}, {
  component: CreateTeamWizard,
  path: '/skapa-lag'
}];
if (svs.core.detect.feature('ft-marketplace-seperation')) {
  switchedRoutes.push({
    path: '/andelar',
    exact: true,
    render: () => React.createElement(WelcomeScreen, {
      type: "retail"
    })
  });
  switchedRoutes.push({
    path: '/',
    exact: true,
    render: () => React.createElement(WelcomeScreen, {
      type: "together"
    })
  });
} else {
  switchedRoutes.push({
    component: WelcomeScreen,
    path: '/',
    exact: true
  });
}
const StartOverview = () => React.createElement(React.Fragment, null, React.createElement(Route, {
  component: RedirectToTeamSlugContainer,
  exact: true,
  key: "team_redirect",
  path: ["".concat(teamBaseRoute, ":additionalPath(/.*?)*"), "".concat(retailTeamBaseRoute, ":additionalPath(/.*?)*")]
}), switchedRoutes.map(_ref => {
  let {
    path,
    exact,
    component,
    render
  } = _ref;
  return React.createElement(Route, {
    component: component,
    exact: exact,
    key: path,
    path: path,
    render: render
  });
}));
setGlobal('svs.marketplace.components.router.StartOverview', StartOverview);
 })(window);